<p-dialog header="Header"
          [(visible)]="visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          styleClass="w-max max-w-full min-w-[50vw] lg:min-w-[33.33vw]">
  <ng-template #header>
    <div class="flex-flex-col w-full gap-1">
      <label class="text-left font-bold">{{ isNew ? ( 'newDept' | translate ) : ( 'editDept' | translate ) }}</label>
      <p-divider />
    </div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="grid w-full grid-cols-3 items-center gap-3 p-4">
      <label for="departmentId" class="text-left font-semibold">ID</label>
      <input pInputText id="departmentId" class="orgdept-input col-span-2" [disabled]="true" [(ngModel)]="department.departmentId" />

      <label for="name" class="text-left font-semibold">{{ 'name' | translate }}</label>
      <input pInputText id="name" class="orgdept-input col-span-2" [disabled]="!isNew" [(ngModel)]="department.name" />
    </div>

    <div class="grid w-full grid-cols-3 items-center gap-3 px-4">
      <label for="organization" class="text-left font-semibold">{{ 'organization' | translate }}</label>
      <p-select id="organization" [options]="organizationOptions" optionLabel="value" [(ngModel)]="selectedOrganization" class="col-span-2 text-left" appendTo="body" [disabled]="!isNew" />
    </div>

    <p-tabs [(value)]="tabsId">
      <p-tablist>
        <p-tab value="0">{{ 'services' | translate}}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="grid auto-cols-max grid-flow-col items-center gap-3">
            <label class="col-start-1 text-left" [innerHTML]="getServiceName(type.EcgDisplay) | translate"></label>
            <p-selectbutton class="col-start-2" [options]="activeOptions" [ngModel]="checkIsActive(type.EcgDisplay)" optionLabel="label" optionValue="value" [disabled]="!isSuperAdmin" (onOptionClick)="onServiceSelection(type.EcgDisplay, $event)" />
            <div class="col-start-3">
              @if (checkIsActive(type.EcgDisplay)) {
              <div class="flex flex-row items-center justify-between gap-3">
                <label>{{ getServiceInfo(type.EcgDisplay) | async }}</label>
                @if (isSuperAdmin) {
                <p-button icon="pi pi-file-edit" (click)="onShowConfiguration(type.EcgDisplay)" />
                }
              </div>
              } @else {
              <div class="flex flex-row items-center justify-between gap-3">
                @if (!isSuperAdmin) {
                <p-button icon="pi pi-info" [rounded]="true" [outlined]="true" [pTooltip]="'messages.callActivation' | translate" showDelay="500" hideDelay="300" />
                }
              </div>
              }
            </div>

            <label class="col-start-1 text-left" [innerHTML]="getServiceName(type.Breath) | translate"></label>
            <p-selectbutton class="col-start-2" [options]="activeOptions" [ngModel]="checkIsActive(type.Breath)" optionLabel="label" optionValue="value" [disabled]="!isSuperAdmin" (onOptionClick)="onServiceSelection(type.Breath, $event)" />
            <div class="col-start-3">
              @if (checkIsActive(type.Breath)) {
              <div class="flex flex-row items-center justify-between gap-3">
                <label>{{ getServiceInfo(type.Breath) | async }}</label>
                @if (isSuperAdmin) {
                <p-button icon="pi pi-file-edit" (click)="onShowConfiguration(type.Breath)" />
                }
              </div>
              } @else {
              <div class="flex flex-row items-center justify-between gap-3">
                @if (!isSuperAdmin) {
                <p-button icon="pi pi-info" [rounded]="true" [outlined]="true" [pTooltip]="'messages.callActivation' | translate" showDelay="500" hideDelay="300" />
                }
              </div>
              }
            </div>

            <label class="col-start-1 text-left" [innerHTML]="getServiceName(type.Gait) | translate"></label>
            <p-selectbutton class="col-start-2" [options]="activeOptions" [ngModel]="checkIsActive(type.Gait)" optionLabel="label" optionValue="value" [disabled]="!isSuperAdmin" (onOptionClick)="onServiceSelection(type.Gait, $event)" />
            <div class="col-start-3">
              @if (checkIsActive(type.Gait)) {
              <div class="flex flex-row items-center justify-between gap-3">
                <label>{{ getServiceInfo(type.Gait) | async }}</label>
                @if (isSuperAdmin) {
                <p-button icon="pi pi-file-edit" (click)="onShowConfiguration(type.Gait)" />
                }
              </div>
              } @else {
              <div class="flex flex-row items-center justify-between gap-3">
                @if (!isSuperAdmin) {
                <p-button icon="pi pi-info" [rounded]="true" [outlined]="true" [pTooltip]="'messages.callActivation' | translate" showDelay="500" hideDelay="300" />
                }
              </div>
              }
            </div>

            <div class="col-start-1 flex flex-col">
              <label class="text-left" [innerHTML]="getServiceName(type.Posture) | translate"></label>
              <label class="text-left" [innerHTML]="getServiceName(42) | translate"></label>
            </div>
            <p-selectbutton class="col-start-2" [options]="activeOptions" [ngModel]="checkIsActive(type.Posture)" optionLabel="label" optionValue="value" [disabled]="!isSuperAdmin" (onOptionClick)="onServiceSelection(type.Posture, $event)" />
            <div class="col-start-3">
              @if (checkIsActive(type.Posture)) {
              <div class="flex flex-row items-center justify-between gap-3">
                <label>{{ getServiceInfo(type.Posture) | async }}</label>
                @if (isSuperAdmin) {
                <p-button icon="pi pi-file-edit" (click)="onShowConfiguration(type.Posture)" />
                }
              </div>
              } @else {
              <div class="flex flex-row items-center justify-between gap-3">
                @if (!isSuperAdmin) {
                <p-button icon="pi pi-info" [rounded]="true" [outlined]="true" [pTooltip]="'messages.callActivation' | translate" showDelay="500" hideDelay="300" />
                }
              </div>
              }
            </div>

            <label class="col-start-1 text-left" [innerHTML]="getServiceName(type.Hrv) | translate"></label>
            <p-selectbutton class="col-start-2" [options]="activeOptions" [ngModel]="checkIsActive(type.Hrv)" optionLabel="label" optionValue="value" [disabled]="!isSuperAdmin" (onOptionClick)="onServiceSelection(type.Hrv, $event)" />
            <div class="col-start-3">
              @if (checkIsActive(type.Hrv)) {
              <div class="flex flex-row items-center justify-between gap-3">
                <label>{{ getServiceInfo(type.Hrv) | async }}</label>
                @if (isSuperAdmin) {
                <p-button icon="pi pi-file-edit" (click)="onShowConfiguration(type.Hrv)" />
                }
              </div>
              } @else {
              <div class="flex flex-row items-center justify-between gap-3">
                @if (!isSuperAdmin) {
                <p-button icon="pi pi-info" [rounded]="true" [outlined]="true" [pTooltip]="'messages.callActivation' | translate" showDelay="500" hideDelay="300" />
                }
              </div>
              }
            </div>

            <label class="col-start-1 text-left" [innerHTML]="getServiceName(type.Afib) | translate"></label>
            <p-selectbutton class="col-start-2" [options]="activeOptions" [ngModel]="checkIsActive(type.Afib)" optionLabel="label" optionValue="value" [disabled]="!isSuperAdmin" (onOptionClick)="onServiceSelection(type.Afib, $event)" />
            <div class="col-start-3">
              @if (checkIsActive(type.Afib)) {
              <div class="flex flex-row items-center justify-between gap-3">
                <label>{{ getServiceInfo(type.Afib) | async }}</label>
                @if (isSuperAdmin) {
                <p-button icon="pi pi-file-edit" (click)="onShowConfiguration(type.Afib)" />
                }
              </div>
              } @else {
              <div class="flex flex-row items-center justify-between gap-3">
                @if (!isSuperAdmin) {
                <p-button icon="pi pi-info" [rounded]="true" [outlined]="true" [pTooltip]="'messages.callActivation' | translate" showDelay="500" hideDelay="300" />
                }
              </div>
              }
            </div>

            <p-divider class="col-span-3 col-start-1" />

            <label class="col-start-1 text-left" [innerHTML]="getServiceName(type.AddUsers) | translate"></label>
            <p-selectbutton class="col-start-2" [options]="activeOptions" [ngModel]="checkIsActive(type.AddUsers)" optionLabel="label" optionValue="value" [disabled]="!isSuperAdmin" (onOptionClick)="onServiceSelection(type.AddUsers, $event)" />
            <div class="col-start-3">
              @if (checkIsActive(type.AddUsers)) {
              <div class="flex flex-row items-center justify-between gap-3">
                <label>{{ getServiceInfo(type.AddUsers) | async }}</label>
                @if (isSuperAdmin) {
                <p-button icon="pi pi-file-edit" (click)="onShowConfiguration(type.AddUsers)" />
                }
              </div>
              } @else {
              <div class="flex flex-row items-center justify-between gap-3">
                @if (!isSuperAdmin) {
                <p-button icon="pi pi-info" [rounded]="true" [outlined]="true" [pTooltip]="'messages.callActivation' | translate" showDelay="500" hideDelay="300" />
                }
              </div>
              }
            </div>

            <label class="col-start-1 text-left" [innerHTML]="getServiceName(type.LongReport) | translate"></label>
            <p-selectbutton class="col-start-2" [options]="activeOptions" [ngModel]="checkIsActive(type.LongReport)" optionLabel="label" optionValue="value" [disabled]="!isSuperAdmin" (onOptionClick)="onServiceSelection(type.LongReport, $event)" />
            <div class="col-start-3">
              @if (checkIsActive(type.LongReport)) {
              <div class="flex flex-row items-center justify-between gap-3">
                <label>{{ getServiceInfo(type.LongReport) | async }}</label>
                @if (isSuperAdmin) {
                <p-button icon="pi pi-file-edit" (click)="onShowConfiguration(type.LongReport)" />
                }
              </div>
              } @else {
              <div class="flex flex-row items-center justify-between gap-3">
                @if (!isSuperAdmin) {
                <p-button icon="pi pi-info" [rounded]="true" [outlined]="true" [pTooltip]="'messages.callActivation' | translate" showDelay="500" hideDelay="300" />
                }
              </div>
              }
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  <ng-template #footer>
    <p-button [label]="'primeng.aria.close' | translate"
              severity="secondary"
              variant="outlined"
              (click)="onClose()" />
    <p-button [label]="'save' | translate"
              (click)="onSave()"
              [disabled]="selectedOrganization.id==0" />
  </ng-template>
</p-dialog>

<p-dialog [header]="'serviceConfig' | translate"
          [(visible)]="showConfiguration"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false">

  <ng-template #header>
    <div class="grid w-full grid-cols-3 items-center gap-3 p-4">
      <label for="service" class="text-left font-semibold">{{ 'service' | translate }}</label>
      <input pInputText id="service" class="col-span-2" [disabled]="true" [ngModel]="getServiceName(selectedService.serviceId) | translate" />
    </div>
  </ng-template>

  <div class="grid grid-cols-3 items-center gap-3">
    <label class="col-start-1 text-left">{{ 'mode' | translate }}</label>
    <p-selectbutton [options]="modeOptions" [ngModel]="useLimit" optionLabel="label" optionValue="value" (onOptionClick)=onModeSelection() />
  </div>
  <p-divider />
  <div class="grid grid-cols-3 gap-3">
    <label class="col-start-1 self-center text-left">{{ 'functions.maxExecutions' | translate }}</label>
    <p-inputnumber class="col-span-2 self-center" [(ngModel)]="selectedService.limit" [min]="0" [disabled]="!useLimit" />

    <label class="col-start-1 self-center text-left">{{ 'functions.maxMonths' | translate }}</label>
    <p-inputnumber class="col-span-2 self-center" [(ngModel)]="selectedService.expirationMonths" [min]="1" [disabled]="useLimit" />

    <label class="col-start-1 self-center text-left">{{ 'functions.autoRenew' | translate }}</label>
    <p-toggleswitch class="self-center justify-self-start" [(ngModel)]="selectedService.autoRenewal" />
  </div>

  <ng-template #footer>
    <p-button [label]="'primeng.aria.close' | translate"
              severity="secondary"
              variant="outlined"
              (click)="showConfiguration=false" />
    <p-button [label]="'confirm' | translate"
              (click)="onUpdateConfiguration()" />
  </ng-template>
</p-dialog>
